<template>
    <div>
        <Modal v-model="addEditModal" :title="!enterpriseWechatRobotForm.id ? $t('alarms.common.add'): $t('alarms.common.edit')" :loading="loading" @on-ok="submit('enterpriseWechatRobotForm')" @on-cancel="cancel('enterpriseWechatRobotForm')" :mask-closable="false" :okText="!enterpriseWechatRobotForm.id ? $t('alarms.common.add'):$t('alarms.common.edit')" :cancelText="$t('alarms.common.cancel')">
            <Form ref="enterpriseWechatRobotForm" :model="enterpriseWechatRobotForm" :label-width="130" :rules="ruleValidate">
                <!-- 机器人名称 -->
                <FormItem :label="$t('alarm_contact.robotName')" prop="name">
                    <Input type="text" v-model="enterpriseWechatRobotForm.name" style="width:300px;"></Input>
                </FormItem>

                <!-- 公司 -->
                <div v-if="company == 1">
                    <FormItem :label="$t('alarm_contact.companyName')" prop="companyId">
                        <Select filterable v-model="companyId" style="width:300px;" placeholder="">
                            <Option :value="item.id" v-for="(item,index) in companyList" v-bind:key="index">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </div>

                <!-- 企业微信机器人URL -->
                <FormItem :label="$t('alarms.common.enterpriseWeChatRobotURL')" prop="webhookUrl">
                    <Input type="text" v-model="enterpriseWechatRobotForm.webhookUrl" style="width:300px;"></Input>
                </FormItem>

                <!-- 监控模块 -->
                <FormItem :label="$t('alarm_contact.monitorModule')" prop="monitorModule">
                    <Select filterable v-model="enterpriseWechatRobotForm.monitorModule" multiple style="width:300px;" placeholder="">
                        <Option :value="item.id" v-for="item in monitorModuleList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>
<script>
    import {setCookie, getCookie} from '../../../utils/cookieUtil.js'
    import TableEnterpriseWechatRobot from '../enterprise_wechat_robot/TableEnterpriseWechatRobot.vue'

    var tableEnterpriseWechatRobot = TableEnterpriseWechatRobot;
    var enterpriseWechatRobotVue = {}
    export default {
        data() {
            return {
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                loading: true,
                addEditModal: false,
                monitorModuleList: [],
                enterpriseWechatRobotForm: {
                    name:'',
                    webhookUrl:'',
                    monitorModule: []
                },
                ruleValidate: {
                    name: [
                        {required: true, message: this.$t('alarm_contact.robotNameRequired'), trigger: 'blur'}
                    ],
                    webhookUrl: [
                        {required: true, message: this.$t('alarm_contact.robotUrlRequired'), trigger: 'blur'}
                    ],
                    monitorModule: [
                        {required: true, message: this.$t('alarm_contact.selectMonitorModule'), trigger: 'change', type: 'array'}
                    ]
                }
            }
        },
        beforeCreate: function () {
            enterpriseWechatRobotVue = this
        },
        mounted: function () {
            if (this.company == 1) {
                enterpriseWechatRobotVue.getCompanyDropDownBox();
            }
            // 查询监控模块和报警用户
            enterpriseWechatRobotVue.searchMonitorModule();
        },
        methods: {
            /*********************************  添加&编辑  ************************************/
            init: function(id){
                this.enterpriseWechatRobotForm.id = id || 0;
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['enterpriseWechatRobotForm'].resetFields();
                    // 编辑
                    if(this.enterpriseWechatRobotForm.id){
                        this.$api.enterpriseWechatRobot.getEnterpriseWechatRobotInfoById("id",this.enterpriseWechatRobotForm.id)
                        .then(res => {
                            // 机器人名称
                            this.enterpriseWechatRobotForm.name=res.data.name;
                            // 公司
                            this.companyId=res.data.companyId;
                            // 企业微信机器人URL
                            this.enterpriseWechatRobotForm.webhookUrl=res.data.webhookUrl;
                            // 监控模块
                            this.enterpriseWechatRobotForm.monitorModule=res.data.monitorModules;
                        })
                    }
                })
                this.addEditModal=true;
            },
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
                this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                .then(res => {
                    this.companyList = res.data;
                });
            },
            // 查询监控模块和报警用户
            searchMonitorModule: function () {
                this.$api.alertRule.searchMonitorModule("userName", getCookie(global.cookieName))
                .then(res => {
                    this.monitorModuleList = res.data;
                })
            },
            submit: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        var enterpriseWechatRobotDate={
                            "name": this.enterpriseWechatRobotForm.name,
                            "companyId": (this.companyId == null || this.companyId == '' || this.companyId == undefined) ? this.company : this.companyId,
                            "webhookUrl": this.enterpriseWechatRobotForm.webhookUrl,

                            "monitorModules": this.enterpriseWechatRobotForm.monitorModule
                        };

                        if(this.enterpriseWechatRobotForm.id>0){
                            enterpriseWechatRobotDate.id=this.enterpriseWechatRobotForm.id;
                            // 编辑
                            enterpriseWechatRobotVue.$api.enterpriseWechatRobot.createOrUpdate(enterpriseWechatRobotDate)
                            .then(res => {
                                setTimeout(() => {
                                    tableEnterpriseWechatRobot.methods.showAll();
                                    this.loading = false;
                                    this.$nextTick(() => {
                                        this.loading = true;
                                    });
                                    this.$Message.success(this.$t('common.editSuccess'));
                                    this.addEditModal = false;
                                },1000);
                            })
                        }else{
                            // 添加
                            enterpriseWechatRobotVue.$api.enterpriseWechatRobot.createOrUpdate(enterpriseWechatRobotDate)
                            .then(res => {
                                setTimeout(() => {
                                    tableEnterpriseWechatRobot.methods.showAll();
                                    this.$refs[name].resetFields();
                                    this.loading = false;
                                    this.$nextTick(() => {
                                        this.loading = true;
                                    });
                                    this.$Message.success(this.$t('common.addSuccess'));
                                    this.addEditModal = false;
                                },1000);
                            })
                        }
                    } else {
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if(this.enterpriseWechatRobotForm.id>0){
                            this.$Message.error(this.$t('common.editFail'));
                        }else{
                            this.$Message.error(this.$t('common.addFail'));
                        }
                    }
                });
            },
            cancel: function (name) {
                this.addEditModal=false;
                this.$refs[name].resetFields();
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/alarm_contact/enterprise_wechat_robot/AddEnterpriseWechatRobot.vue